export default "__VITE_ASSET__252f89d2__"